import React, { createContext, PropsWithChildren, useMemo, useState } from 'react';

export type FlexyDatatableTableContextType<T extends Record<string, unknown> & { id: unknown }> = {
    selectedItems: T[];
    setSelectedItems: (items: T[]) => void;
    currentData: T[];
    setCurrentData: (items: T[]) => void;
};

export const FlexyDatatableTableContext = createContext<
    FlexyDatatableTableContextType<Record<string, unknown> & { id: unknown }>
>({
    selectedItems: [],
    setSelectedItems: () => {},
    currentData: [],
    setCurrentData: () => {},
});

export const FlexyDatatableTableProvider = function (props: PropsWithChildren) {
    const { children } = props;
    const [selectedItems, setSelectedItems] = useState<
        Array<Record<string, unknown> & { id: unknown }>
    >([]);
    const [currentData, setCurrentData] = useState<
        Array<Record<string, unknown> & { id: unknown }>
    >([]);
    const datatableContextValue = useMemo(
        () => ({ selectedItems, setSelectedItems, currentData, setCurrentData }),
        [selectedItems, setSelectedItems, currentData, setCurrentData],
    );

    return (
        <FlexyDatatableTableContext.Provider value={datatableContextValue}>
            {children}
        </FlexyDatatableTableContext.Provider>
    );
};
